module.exports = __webpack_public_path__ + "static/img/015.ce54e35.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/templates/sotet-konyha/sample-thumbnails/015.jpg
// module id = 872
// module chunks = 0